import { useQuery } from "@tanstack/react-query"

import { TaxCategoriesService } from "../generated"

export const useTaxCategories = (parentId: number) =>
  useQuery(["taxCategories"], () => TaxCategoriesService.taxCategoriesGetAllAsync({ parentId }))

export const useTaxCategory = (parentId: number, id: UUID) =>
  useQuery(["taxCategories", id], () => TaxCategoriesService.taxCategoriesGetAsync({ parentId, id }))
